// Define user roles within the system
const Roles = {
    ORG_OWNER: "Organization Owner",     // Can create and manage organizations and add admins.
    ORG_ADMIN: "Organization Admin",     // Can manage the organization and add collaborators.
    ORG_COLLAB: "Organization Collaborator", // Involved in collaborative tasks within an organization.
    ORG_GUEST: "Organization Guest",     // Has limited access, typically for viewing or limited interaction.
};

export default Roles;
